import React from "react";

const CustomRadioButton = ({ label, value, checked, onChange }) => {
  return (
    <label className="custom-radio">
      <input type="radio" value={value} checked={checked} onChange={onChange} />
      <span className="custom-radio-checkmark">
        <div>{label}</div>
      </span>
    </label>
  );
};

export default CustomRadioButton;
